<template>
  <div id="pright" >

    <div v-if="poslato" class="pslto">
      <h2>Porudžba je uspješno poslata!</h2>
      <p>Kontaktiraćemo vas u periodu od 08h do 16h telefonom radi dogovora oko plaćanja i isporuke.<br>
         Ukoliko je u okviru radnog vremena možete i vi kontaktirati nas na 067 626 673</p>

      <p>
         ID porudžbe: {{zinf.prid}}<br>
         Ime: {{zinf.ime}}<br>
         Grad: {{zinf.grad}}<br>
         Br. tel.: {{zinf.brtel}}<br>
         Email: {{zinf.email}}<br>
         Poruka: {{zinf.poruka}}<br><br>
      </p>

      <table>
        <tr v-for="(item) in zinf.arlist" :key="item.id">
          <td style="height:40px; width:70px; border-bottom:1px solid #aaa;"><a :href="item.url"><img :src="item.img" :alt="item.naziv" style="height:100%;position:relative"></a></td>
          <td style="height:40px; width:400px; border-bottom:1px solid #aaa; text-align: left; padding: 0px 10px; font-size:13px; font-weight:500"><a :href="item.url">{{item.naziv}}<br><span style="font-size:12px; font-weight: 300">{{item.boja}}</span></a></td>
          <td style="height:40px; width:40px; border-bottom:1px solid #aaa; text-align: right"><div style="font-size: 10px; color: #a00" v-if="item.akcija == 1">AKCIJA</div>{{item.cijena}}€</td>
          <td style="height:40px; width:20px; border-bottom:1px solid #aaa; text-align: center">{{item.kolicina}}</td>
          <td style="height:40px; width:40px; border-bottom:1px solid #aaa; text-align: right">{{item.cijena * item.kolicina}}€</td>
        </tr>
        <tr><td colspan="3" style="text-align:right; font-size: 16px; font-weight: 400;">UKUPNO</td><td colspan="2" style="font-size: 16px; font-weight: 900; text-align:right">{{zinf.ukupno}}</td></tr>
      </table>
      <p>Da započnete novu trgovinu, počnite sa odabirom artikala.</p>
      <p>Ukoliko niste primili email obajveštenje o porudžbi provjerite i spam poruke.
      </p>

    </div>
    <div v-if="majList.length === 0 && !poslato" style="padding: 14px;">Nema izabranih artikala. Izaberite artike klikom na cijenu. Vaš ID je {{this.numid}}</div>
    <table id="tabls" v-if="!poslato && majList.length > 0">
      <tr class="tItem" v-for="(item, index) in majList.slice().reverse()" :key="item.artikli_id">
        <td class="td1"><div class="indxx">{{index + 1}}</div><router-link :to="'/ponuda/' + item.kategorija_url + '/' + item.artikli_id + '/' + item.podkat_url + '-' +  item.artikli_naziv.toLowerCase().replace(' ', '-')"><img :src="'/images/namjestaj/' + item.artikli_id + '/0.jpg'" :alt="item.artikli_naziv" style="height:100%;position:relative"></router-link></td>
        <td class="td2"><router-link :to="'/ponuda/' + item.kategorija_url + '/' + item.artikli_id + '/'  + item.podkat_url + '-' +  item.artikli_naziv.toLowerCase().replace(' ', '-')">{{item.podkat_naziv}} {{item.artikli_naziv}}<br><span class="spanst" v-if="item.artikli_boje">{{item.artikli_boje}}</span></router-link></td>
        <td class="td3">{{item.artikli_donjacijena.toString().split('').reverse().join('').match(/.{1,3}/g).join('.').split('').reverse().join('')}}€<div class="aDiv" v-if="item.artikli_akcija==1">AKCIJA</div></td>
        <td class="td4">{{item.artikli_kolicina}}<span id="dodaj" class="klk" v-on:click.prevent="dodaj(majList.length - 1 - index)">+</span>        <span class="remBtn klk" v-on:click.prevent="makni(majList.length - 1 - index)">-</span></td>
        <td class="td5">{{(item.artikli_kolicina * item.artikli_donjacijena).toString().split('').reverse().join('').match(/.{1,3}/g).join('.').split('').reverse().join('')}}€</td>
      </tr>
    </table>
        <div id="ctc">
      <div v-if="!poslato && majList.length > 0">
        <h2>Popunite porudžbu</h2>
        <p style="position:relative; top: -1vw; margin-bottom:0px">Unesite Vaše podatke</p>
        <input v-model.lazy="ime" placeholder="Ime i Prezime" :disabled="salje">
        <input v-model.lazy="grad" placeholder="Grad " :disabled="salje">
        <input type="number" v-model.lazy="brtel" placeholder="Broj telefona" :disabled="salje">
        <input type="email" v-model.lazy="email" placeholder="Email" :disabled="salje">
        <textarea v-model.lazy="poruka" placeholder="Poruka (opciono)" :disabled="salje"></textarea>
        <br><br>
        <span>Moj ID: <strong>{{this.numid}}</strong></span>
        <span>Broj artikala: <strong>{{this.koms}}</strong></span>
        <span>Ukupan iznos: <strong>{{this.zbirs}}€</strong></span>
        <div id="ctcBtn" @click="pozMe()" v-if="!salje">Pošalji porudžbu</div>
        <img v-else src="../assets/loading.gif" style="height: 2em; margin-top: 1em;">
      </div>
    </div>
    <div id="spacer">&nbsp;</div>
  </div>
</template>

<script>

export default {
  name: 'MojiArt',
  components: {
  },
  data () {
    return {
      itemList: [],
      tempList: [],
      intr: '',
      ime: '',
      grad: '',
      brtel: '',
      email: '',
      poruka: '',
      salje: false,
      poslato: false,
      zapos: [],
      zinf: {}
    }
  },
  metaInfo () {
    return {
      title: 'Moji artikli - VND online diskont namještaja',
      meta: [
        { name: 'description', content: 'Odaberite artikle i pošaljite porudžbu, ili nas kontaktirajte putem telefona kako bi vam pomogli u odabiru. Besplatna isporuka namještaja na teritoriji Crne Gore. Mogućnost plaćanja pouzećem.' },
        { property: 'og:type', content: 'website' },
        { property: 'og:site_name', content: 'vndnamjestaj' },
        { property: 'og:title', content: 'Moji artikli - VND online diskont namještaja' },
        { property: 'og:image', content: this.sImage },
        { property: 'og:url', content: 'https://vndnamjestaj.me' + this.$route.path }
      ]
    }
  },
  props: {
    dob: String
  },
  created () {

  },
  mounted: function () {
    this.poslato = (localStorage.getItem('poslato') === 'true')
    this.zinf = JSON.parse(localStorage.getItem('zinf'))
    if (this.zinf.ime) {
      this.ime = this.zinf.ime
      this.grad = this.zinf.grad
      this.brtel = this.zinf.brtel
      this.email = this.zinf.email
      this.poruka = this.zinf.poruka
    }
  },
  methods: {
    makni (idx) {
      this.$store.dispatch('makniMoj', idx)
    },
    dodaj (id) {
      this.$store.dispatch('dodMoj2', this.majList[id])
    },
    ocisti () {
      this.$store.dispatch('clearMoj')
    },
    pozMe: async function () {
      this.salje = true
      if (this.ime.length > 2 && this.grad.length > 1 && this.brtel.length > 5) {
        this.zapos = this.majList.map(item => ({
          id: item.artikli_id,
          naziv: item.podkat_naziv + ' ' + item.artikli_naziv,
          boja: item.artikli_boje,
          cijena: item.artikli_donjacijena,
          url: 'https://vndnamjestaj.me/ponuda/' + item.kategorija_url + '/' + item.artikli_id + '/' + item.podkat_url + '-' + item.artikli_naziv.toLowerCase().replace(' ', '-'),
          img: 'https://vndnamjestaj.me/images/namjestaj/' + item.artikli_id + '/0.jpg',
          akcija: item.artikli_akcija,
          kolicina: item.artikli_kolicina
        }))
        this.zinf = {}

        this.zinf.ime = this.ime
        this.zinf.grad = this.grad
        this.zinf.brtel = this.brtel
        this.zinf.email = this.email
        this.zinf.poruka = this.poruka
        this.zinf.ukupno = this.zbirs
        this.zinf.arlist = this.zapos

        var req = JSON.stringify({
          ime: this.ime,
          grad: this.grad,
          brtel: this.brtel,
          email: this.email,
          poruka: this.poruka,
          ukupno: this.zbirs,
          arlist: this.zapos,
          numid: this.numid
        })

        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: req
        }

        try {
          var response = await fetch('https://vndnamjestaj.me/ppnc.php', requestOptions)
          const data = await response.json()
          console.log(data)
          if (data.status === '1') {
            this.zinf.prid = data.msg
            this.poslato = true
            this.salje = false
            localStorage.setItem('poslato', true)
            localStorage.setItem('zinf', JSON.stringify(this.zinf))
            this.ocisti()
            this.ime = ''
            this.grad = ''
            this.brtel = ''
            this.email = ''
            this.poruka = ''
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: 'smooth'
            })
          } else {
            this.poslato = false
            localStorage.setItem('poslato', false)
            this.salje = false
            alert('\nDošlo je do greške... Molimo Vas pokušajte ponovo.')
          }
        } catch (err) {
          this.poslato = false
          localStorage.setItem('poslato', false)
          this.salje = false
          alert('\nDošlo je do greške u komunikaciji sa serverom... Molimo Vas pokušajte ponovo.')
        }
      } else {
        alert('\nMorate unijeti Vaše ime, grad za koji je potrebna isporuka, kao i broj telefona na koji ćemo Vas kontaktirati.\n\n Ukoliko želite da primite kopiju porudžbe unesite i email.\n\n')
        this.poslato = false
        localStorage.setItem('poslato', false)
        this.salje = false
      }
    }
  },
  computed: {
    majList () {
      return this.$store.getters.sMoj
    },
    zbirs () {
      if (this.majList.length > 0) {
        return this.majList.reduce(function (a, b) {
          return a + Number(b.artikli_donjacijena) * Number(b.artikli_kolicina)
        }, 0).toString().split('').reverse().join('').match(/.{1,3}/g).join('.').split('').reverse().join('')
      }
      return 0
    },
    koms () {
      return this.majList.reduce((a, b) => a + (b.artikli_kolicina || 0), 0)
    },
    numid () {
      return this.$store.getters.sId
    }
  },
  watch: {
  }
}
</script>
<style lang="scss" scoped>

#tabls{
  position:relative;
  width:68%;
  padding: 2vw 0vw 4vw;
}

.td1{
  height:6vw; width:9vw
}

.td2{
  height:6vw; width:20vw; text-align: left; padding: 0px 10px; font-weight:500
}

.td3{
  height:6vw; width:6vw
}

.td4{
  height:6vw; width:2vw
}

.td5{
  height:6vw; width:6vw
}

.spanst{
  font-size:0.9vw; font-weight: 300
}

.indxx{
  position: absolute;
  left: -2.4vw;
  top: 2vw;
  background-color: #2e7274;
  border-radius: 8vw;
  width: 1.7vw;
  height: 1.7vw;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 900;
  color: #fff;
}

h2{
      font-size: 1.43vw;
}

#ctc{
  width: 17vw;
  position: fixed;
  right: 21vw;
  height: 40vw;
  text-align: left;
  padding: 1vw 2vw;
  font-size: 1vw;
}

#ctc span{
  padding: 0px 0px 1vw;
  position: relative;
  display: block;
}

#ctc input{
  width: 100%;
  padding: 0.3vw;
  margin: 0px 0px 0.5vw;
  font-size: 0.9vw;
}

#ctc textarea{
  width: 100%;
  padding: 0.3vw;
  margin: 0px 0px 0.5vw;
  font-size: 0.9vw;
}

#ctcBtn{
  display: inline;
  padding: 0.6vw 1vw;
  cursor: pointer;
  color: #fff;
  background-color: #d00;
  border-radius: 0.6vw;
  font-weight: 900;
  position: relative;
  top: 1vw;
}

#ctcBtn:hover{
    background-color: #a00;
}

#mHead{
  width: 100%;
  text-align: left;
}

#mHead span{
  margin: 0px 20px
}

#pright{
  display: flex;
  flex-wrap: wrap;
  top: -5.5vw;
  width: 65.5vw;
  right: 0px;
}

.pslto{
  width: 40vw;
  margin: 0px auto;
  text-align: left;
}

.pslto table{
  width: 100%;
}

@media only screen and (max-width: 600px) {
  .pslto{
    width: 90vw;
    margin: 0px auto;
    text-align: left;
  }

    #tabls{
    position:relative;
    width:100%;
    padding: 2vw 0vw 4vw;
  }

  td{
    font-size: 5vw;
  }
  td a{
    font-size: 4vw;
  }
  .td1{
  height:18vw; width:9vw
}

  .indxx{
    position: absolute;
    left: -2.4vw;
    top: 5vw;
    background-color: #2e7274;
    border-radius: 8vw;
    width: 10.7vw;
    height: 6.7vw;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 900;
    color: #fff;
    z-index: 99;
  }

.spanst{
  font-size:4vw; font-weight: 300
}

h2{
      font-size: 6vw;
}

  #ctc{
    width: 90vw;
    position: relative;
    right: auto;
    height: auto;
    text-align: center;
    padding: 1vw 2vw;
    font-size: 1vw;
    left: 5vw;
  }

#ctc span{
  padding: 0px 0px 1vw;
  position: relative;
  display: block;
}

#ctc input{
  width: 100%;
  padding: 2vw;
  margin: 0px 0px 2vw;
  font-size: 4vw;
}

#ctc textarea{
  width: 100%;
  padding: 2vw;
  margin: 0px 0px 2vw;
  font-size: 4vw;
}

#ctcBtn{
  display: inline;
  padding: 2vw 8vw;
  cursor: pointer;
  color: #fff;
  background-color: #d00;
  border-radius: 3vw;
  font-weight: 900;
  position: relative;
  top: 5vw;
}

  #pright{
    width: 100vw;
    padding: 60px 0px 0px;
    overflow: hidden;
    overflow-y: auto;
  }
}

.tItem{
  height: 2vw;
  background-color: #fff;
  position: relative;
  border-radius: 0.8vw;
  overflow: hidden;
  transition: all 0.5s;
  img{
    position: absolute;
    height: 100%;
    left: 0%;
    top: 0%;
  }
  /*
  img:hover{
    height: 104%;
    width: 105%;
    left: -2%;
    top: -2.5%;
  }
  */
}

@media only screen and (max-width: 600px) {
  .item{
    width: 90vw;
    height: calc(90vw * 0.61);
    margin: 14px auto;
    border-radius: 12px;
  }
.tItem{
    height: 2vw;
    background-color: #fff;
    position: relative;
    border-radius: 0.8vw;
    overflow: hidden;
    transition: all 0.5s;
    height: 17vw;
  img{
    position: absolute;
    height: 100%;
    left: 0%;
    top: 0%;
  }
  /*
  img:hover{
    height: 104%;
    width: 105%;
    left: -2%;
    top: -2.5%;
  }
  */
}
}

.list-complete-enter, .list-complete-leave-to{
  opacity: 0;
  transform: translateX(-300px) translateY(-10px);
}
.list-complete-leave-active {
  transform: translateX(-300px);
  position: absolute;
}

.gad{
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  padding-bottom: 5vw;
  align-content: baseline;
  width: 100%;
}

#spacer{
  display: none;
}
@media only screen and (max-width: 600px) {
  .gad{
    display: block;
    text-align: center;
    width: 100vw;
    position: relative;
  }
  #spacer{
    display: block;
    height: 18vh;
    width: 300px;
  }
}

.cijena{
  position: absolute;
  z-index: 888;
  color: #000;
  background-color: #FD0;
  width: 6vw;
  height: 2.4vw;
  border-radius: 1.6vw 0px 0px 0px;
  bottom: -0.25vw;
  right: -0.1vw;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 900;
  font-size: 1vw;
  box-shadow: 0px 0px 0.6vw 0px RGBA(0, 0, 0, 0.3);
  transition: width 0.3s;
}

.cijena:hover{
  width: 6vw;
}

#dodaj{
  opacity: 1;
  position: absolute;
  background-color: #fff;
  border-radius: 30px;
  width: 1.2vw;
  height: 1.2vw;
  top: 0.8vw;
  left: 0.3vw;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0.05vw 0.05vw 0.2vw 0px RGBA(0,0,0,0.3);
  font-weight: 400;
  transition: opacity 0.3s;
  color: #db0;
  font-size: 0.8vw;
}

.remBtn{
  width: 1.2vw;
  height: 1.2vw;
  bottom: 1vw;
  left: 0.3vw;
  position: absolute;
  z-index: 99999;
  border-radius: 1.2vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  box-shadow: 0.05vw 0.05vw 0.2vw 0px RGBA(0,0,0,0.3);
  opacity: 1;
  font-weight: 400;
  transition: opacity 0.3s;
  color: #db0;
  font-size: 1vw;
}

.remBtn:hover{
  opacity: 1;
}

td{
  position:relative;
}

.aDiv{
  position: absolute;
  z-index: 888;
  color: #F00;
  width: 5vw;
  height: 2.3vw;
  top: 0.4vw;
  right: 0.5vw;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 900;
  font-size: 1vw;
  background-color: RGBA(0, 0, 0, 0.0);
  border-radius: 0px 0px 0px 1.6vw;
}

@media only screen and (max-width: 600px) {
  .cijena{
    position: absolute;
    z-index: 888;
    color: #000;
    background-color: #FD0;
    width: 60px;
    height: 30px;
    border-radius: 14px 0px 0px 0px;
    bottom: -0.25vw;
    right: -0.1vw;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 900;
    font-size: 18px;
    box-shadow: 0px 0px 0.6vw 0px RGBA(0, 0, 0, 0.3);
  }
.aDiv{
  position: absolute;
  z-index: 888;
  color: #F00;
  width: 5vw;
  height: 2.3vw;
  top: 1.4vw;
  right: 4vw;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 900;
  font-size: 3vw;
  background-color: RGBA(0, 0, 0, 0.0);
  border-radius: 0px 0px 0px 1.6vw;
}

  #dodaj{
        opacity: 1;
    position: absolute;
    background-color: #fff;
    border-radius: 30px;
    width: 5.2vw;
    height: 5.2vw;
    top: 0.8vw;
    left: -0.6vw;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0.05vw 0.05vw 1.2vw 0px RGBA(0, 0, 0, 0.3);
    font-weight: 400;
    transition: opacity 0.3s;
    color: #db0;
    font-size: 3.8vw;
  }

  .remBtn{
    width: 5.2vw;
    height: 5.2vw;
    bottom: 1vw;
    left: -0.6vw;
    position: absolute;
    z-index: 99999;
    border-radius: 5.2vw;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    box-shadow: 0.05vw 0.05vw 1.2vw 0px RGBA(0, 0, 0, 0.3);
    opacity: 1;
    font-weight: 400;
    transition: opacity 0.3s;
    color: #db0;
    font-size: 8vw;
  }
}

.naziv{
  position: absolute;
  bottom: 0.4vw;
  left: 0.5vw;
  font-weight: 400;
  color: #fff;
  text-shadow: 0.1vw 0.1vw 0.2vw RGBA(0, 0, 0, 0.6);
}

</style>
